import React from "react";
import {
  ScrollText,
  Gavel,
  Ban,
  MonitorPlay,
  Copyright,
  ShieldAlert,
} from "lucide-react";

function KullanimSartlari() {
  return (
    <div className="max-w-6xl mx-auto p-6 bg-gray-50 min-h-screen">
      <div className="text-center mb-12">
        <div className="inline-flex items-center justify-center gap-3 mb-6">
          <div className="bg-purple-500 p-3 rounded-full shadow-lg">
            <ScrollText className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900 uppercase">
            Kullanım Şartları
          </h1>
        </div>
        <p className="text-gray-600 max-w-2xl mx-auto">
          My Classroom platformuna erişim sağlayarak aşağıdaki şartları kabul
          etmiş sayılırsınız.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white p-8 rounded-3xl shadow-md border-t-4 border-purple-500">
          <Copyright className="w-10 h-10 text-purple-500 mb-4" />
          <h3 className="font-bold text-lg mb-2">Fikri Mülkiyet</h3>
          <p className="text-sm text-gray-600">
            Tüm video ve içerikler Ali Zilan'a aittir. Kopyalanması veya izinsiz
            paylaşılması yasaktır.
          </p>
        </div>

        <div className="bg-white p-8 rounded-3xl shadow-md border-t-4 border-purple-500">
          <MonitorPlay className="w-10 h-10 text-purple-500 mb-4" />
          <h3 className="font-bold text-lg mb-2">Bireysel Kullanım</h3>
          <p className="text-sm text-gray-600">
            Hesaplar şahsidir. Bir üyeliğin birden fazla kişi tarafından
            kullanılması hesabın askıya alınma sebebidir.
          </p>
        </div>

        <div className="bg-white p-8 rounded-3xl shadow-md border-t-4 border-purple-500">
          <ShieldAlert className="w-10 h-10 text-purple-500 mb-4" />
          <h3 className="font-bold text-lg mb-2">Hizmet Değişikliği</h3>
          <p className="text-sm text-gray-600">
            Classroom, eğitim içeriklerini güncelleme veya değiştirme hakkını
            saklı tutar.
          </p>
        </div>
      </div>
    </div>
  );
}

export default KullanimSartlari;
